import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeToggleComponent } from '@/app/shared/components/theme-toggle/theme-toggle.component';
import { ParticlesComponent } from '@/app/shared/components/ui/particles/particles.component';
import { MagicCardComponent } from '@/app/shared/components/ui/magic-card/magic-card.component';

@Component({
  standalone: true,
  selector: 'app-about-us',
  imports: [
    CommonModule,
    ThemeToggleComponent,
    ParticlesComponent,
    MagicCardComponent,
  ],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
})
export class AboutUsComponent {
  isMobileMenuOpen = false;
  isDarkTheme = true;

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
    }
  }

  onThemeChange(isDarkMode: boolean) {
    this.isDarkTheme = isDarkMode;
  }
}